import { useContext, useEffect, useState } from "react";
import EnterpriseService from "../../common/services/enterprise-service";
import { EnterpriseContext } from "./EnterpriseContext";
import AggregatedStatsCharts from "./AggregatedStatsCharts";
import UserDefinedUnits from "../../common/utils/UserDefinedUnits";
import moment from "moment";
import CountUp from "react-countup";
import { Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AllTimeCompanyStats({
  container,
  company,
  stats,
  awards,
}) {
  const { globalContext } = useContext(EnterpriseContext);
  const [aggregatedStats, setAggregatedStats] = useState(null);
  const member = globalContext.member;
  const es = new EnterpriseService();

  useEffect(() => {
    getAggregatedStats();
  }, []);

  const getAggregatedStats = async () => {
    const result = await es.getCompanyAggregatedStats(globalContext.company.id);
    setAggregatedStats(result);
  };

  return (
    <>
      {aggregatedStats != null && (
        <div>
          <Row className="gx-0">
            <div className="grid cols-3 mb-3">
              <div className="stat-tile stat-tile-with-icon stat-tile-info mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="box" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    <CountUp
                      className="fs-2 fw-bolder"
                      end={aggregatedStats.jobs_delivered}
                    ></CountUp>
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.jobsDelivered}
                  </div>
                </div>
              </div>
              <div className="stat-tile stat-tile-with-icon stat-tile-success mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="road" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    <CountUp
                      className="fs-2 fw-bolder"
                      end={UserDefinedUnits.convertDistanceValue(
                        member,
                        null,
                        aggregatedStats.distance_driven_on_job_km
                      )}
                      suffix={
                        " " + UserDefinedUnits.getDistanceUnitLabel(member, null)
                      }
                      decimal={0}
                    ></CountUp>
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.totDistance}
                  </div>
                </div>
              </div>
              <div className="stat-tile stat-tile-with-icon stat-tile-success mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="flag-checkered" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    <CountUp
                      className="fs-2 fw-bolder"
                      end={UserDefinedUnits.convertDistanceValue(
                        member,
                        null,
                        aggregatedStats.max_real_distance_km
                      )}
                      suffix={
                        " " + UserDefinedUnits.getDistanceUnitLabel(member, null)
                      }
                      decimal={0}
                    ></CountUp>
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.longedJobDistance}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid cols-3 mb-3">
              <div className="stat-tile stat-tile-with-icon stat-tile-info mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="route" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    <CountUp
                      className="fs-2 fw-bolder"
                      end={UserDefinedUnits.convertDistanceValue(
                        member,
                        null,
                        aggregatedStats.avg_real_distance_km
                      )}
                      suffix={
                        " " + UserDefinedUnits.getDistanceUnitLabel(member, null)
                      }
                      decimal={0}
                    ></CountUp>
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.averageJobDistance}
                  </div>
                </div>
              </div>
              <div className="stat-tile stat-tile-with-icon stat-tile-info mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="clock" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    {moment
                      .duration(aggregatedStats.max_driving_time, "seconds")
                      .format("h _ m _")}
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.longestJobTime}
                  </div>
                </div>
              </div>
              <div className="stat-tile stat-tile-with-icon stat-tile-info mb-3 mb-md-0">
                <div className="stat-tile-icon">
                  <FontAwesomeIcon icon="stopwatch" />
                </div>
                <div className="stat-tile-body">
                  <div class="fs-2 fw-bolder counted">
                    {moment
                      .duration(aggregatedStats.avg_driving_time, "seconds")
                      .format("h _ m _")}
                  </div>
                  <div class="fw-bold fs-6 text-gray-600">
                    {container.localeManager.strings.avgJobTime}
                  </div>
                </div>
              </div>
            </div>
          </Row>
          <AggregatedStatsCharts
            container={container}
            stats={aggregatedStats}
          ></AggregatedStatsCharts>
        </div>
      )}
    </>
  );
}
